$(() => $('body').on('click', '#download-pdf-link', (event) => {
  event.preventDefault();
  $('#sent-prospect-email').val('true');
  $('#calculator-form').submit();
  window.open($('#prospect-pdf-url').val(), '_blank');
}));
